import React from 'react';
import Moment from 'moment';

import MovieDetailsDescriptionSdh from './MovieDetailsDescriptionSdh';

class MovieDetails extends React.Component {
  constructor(props) {
    super(props)
    this.genresWithCommas = this.genresWithCommas.bind(this)
    this.movieDuration = this.movieDuration.bind(this)
    this.datesBody = this.datesBody.bind(this)
  }
  genresWithCommas() {
    let genresNames = this.props.film.genres.map(genre => genre.name)
    return genresNames.join(", ")
  }
  movieDuration() {
    let dur = this.props.film.duration
    if (dur < 60) {
      return dur + " хв."
    }
    let hrs = Math.floor(dur / 60).toString()
    let mins = dur % 60
    if (mins === 0) {
      return hrs.toString() + ":00"
    }
    if (mins < 10) {
      return hrs.toString() + ":0" + mins.toString()
    }
    return hrs.toString() + ":" + mins.toString()
  }
  datesBody() {
    if (this.props.film.DateFrom && this.props.film.DateCityTo) {
      return (
        <li className="mvi__kv">
          <p className="mvi__key">Період прокату:</p>
          <p className="mvi__val">{Moment(this.props.film.DateFrom).format("DD.MM.YYYY") + " - " + Moment(this.props.film.DateCityTo).format("DD.MM.YYYY")}</p>
        </li>
      )
    } else if (this.props.film.DateFrom) {
      return (
        <li className="mvi__kv">
          <p className="mvi__key">Дата виходу:</p>
          <p className="mvi__val">{Moment(this.props.film.DateFrom).format("DD.MM.YYYY")}</p>
        </li>
      )
    }
  }

  render() {
    return (
      <div className="mvi__info">
        <div className="wd">
          {this.props.film.innerPoster &&
            <div className="mvi__poster">
              <img src={this.props.film.innerPoster} alt="Альфа" />
              {this.props.film.Rating &&
                <div className="age">{this.props.film.Rating}</div>
              }
            </div>
          }
          <div className="mvi__details">
            {this.props.film.genres && this.props.film.genres.length > 0 &&
              <div className="mvi__genres">
                {
                  this.props.film.genres.map(genre =>
                    <div className="mvi__genre" key={genre.id}>{genre.name}</div>
                  )
                }
              </div>
            }
            <p className="mvi__info__heading mobonly">Про фільм</p>
            <ul className="mvi__kvs">
              {this.props.film.Rating &&
                <li className="mvi__kv">
                  <p className="mvi__key">Вік:</p>
                  <p className="mvi__val">{this.props.film.Rating}</p>
                </li>
              }
              {this.props.film.producer &&
                <li className="mvi__kv">
                  <p className="mvi__key">Оригінальна назва:</p>
                  <p className="mvi__val">{this.props.film.originalName}</p>
                </li>
              }
              {this.props.film.producer &&
                <li className="mvi__kv">
                  <p className="mvi__key">Режисер:</p>
                  <p className="mvi__val">{this.props.film.producer}</p>
                </li>
              }
              {this.datesBody()}
              {/* 
              {this.props.film.mov_rate.imdb &&
                <li className="mvi__kv">
                  <p className="mvi__key">Рейтинг Imdb:</p>
                  <p className="mvi__val">{this.props.film.mov_rate.imdb}</p>
                </li>
              }
              { this.props.film.mov_rate.kinopoisk &&
                <li className="mvi__kv">
                  <p className="mvi__key">Рейтинг Kinopoisk:</p>
                  <p className="mvi__val">{this.props.film.mov_rate.kinopoisk}</p>
                </li>
              } 
               */}
              {this.props.film.language &&
                <li className="mvi__kv">
                  <p className="mvi__key">Мова:</p>
                  <p className="mvi__val">{this.props.film.language}</p>
                </li>
              }
              {this.props.film.genres && this.props.film.genres.length > 0 &&
                <li className="mvi__kv">
                  <p className="mvi__key">Жанр:</p>
                  <p className="mvi__val">{this.genresWithCommas()}</p>
                </li>
              }
              {this.props.film.duration &&
                <li className="mvi__kv">
                  <p className="mvi__key">Тривалість:</p>
                  <p className="mvi__val">{this.movieDuration()}</p>
                </li>
              }
              {this.props.film.Country &&
                <li className="mvi__kv">
                  <p className="mvi__key">Виробництво:</p>
                  <p className="mvi__val">{this.props.film.Country}</p>
                </li>
              }
              {this.props.film.scenario &&
                <li className="mvi__kv">
                  <p className="mvi__key">Сценарій:</p>
                  <p className="mvi__val">{this.props.film.scenario}</p>
                </li>
              }
              {this.props.film.actors &&
                <li className="mvi__kv">
                  <p className="mvi__key">У головних ролях:</p>
                  <p className="mvi__val">{this.props.film.actors}</p>
                </li>
              }

              <MovieDetailsDescriptionSdh film={this.props.film} />

            </ul>
            <div className="mvi__synopsis" dangerouslySetInnerHTML={{ __html: this.props.film.Description }}></div>
          </div>
        </div>
      </div>
    )
  }
}

export default MovieDetails




// WEBPACK FOOTER //
// ./src/components/pages/MoviePage/impl/MovieDetails/MovieDetails.jsx